import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import department from './modules/department'
import auth from './modules/auth'
import school from './modules/school'
import bigPhase from './modules/bigPhase' //大阶段信息
import course from './modules/course' //课程信息
import chapter from './modules/chapter' //章节信息
import barrier from './modules/barrier' //关卡信息
import breadcrumb from './modules/breadcrumb' //记录路径面包屑
import question from './modules/question' //题库管理
import daily from './modules/daily' //每日任务
import score from './modules/score' //积分列表
import log from './modules/log' //系统日志
import revenue from './modules/revenue' //营收流水日志
import pay from './modules/pay' //支付类型列表
import music from './modules/music' //曲库管理
import exam from './modules/exam' //考级课程管理

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    btnLoading:false
  },
  mutations: {
    setBtnLoading(state,status) {
      state.btnLoading = status
    },
    SET_ROUTER_NAME(state,name) {
      state.router_name = name
    }
  },

  getters: {
    SHOW_BREADCRUMB_LIST: state => {
      let i = state.breadcrumb.list.findIndex(item => item.router_name == state.route.name)
      if(i > -1) {
        let list = state.breadcrumb.list.slice(0,i+1)
        return list
      } else {
        return []
      }
    },

    SHOW_BREADCRUMB_LIST2: state => {
      let typeid = ''
      if(state.route.name == 'cate_index') typeid = 'catalogid'
      if(state.route.name == 'exam_index') typeid = 'lessionid'
      let id = state.route.query[typeid] || 0
      let i = state.breadcrumb.list2.findIndex(item => item[typeid] == id)
      if(i > -1) {
        let list = state.breadcrumb.list2.slice(0,i+1)
        return list
      } else {
        return []
      }
    }
  },

  actions: {

  },
  modules: {
    app,
    user,
    department,
    auth,
    school,
    bigPhase,
    course,
    chapter,
    barrier,
    breadcrumb,
    question,
    daily,
    score,
    log,
    revenue,
    pay,
    music,
    exam
  }
});

export default store


// WEBPACK FOOTER //
// ./src/store/index.js